module.exports = __webpack_public_path__ + "img/file_green.e6dc7a15.svg";